/* ADRO engraving customiser, individual purchase and bulk quote controllers */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  // Prices arrive from Liquid already in the customer's market currency (Shopify Markets), so we only format them.
  var CUR = (document.documentElement.getAttribute('data-currency') || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP').toUpperCase();
  // Match Shopify's own money format for this currency (e.g. £1,234.56 or €1.234,56) using a sample rendered by Liquid.
  var SAMPLE = document.documentElement.getAttribute('data-money-sample') || '';
  var FMT = (function () {
    var m = /^([^\d]*)1(\D?)234(\D)56([^\d]*)$/.exec(SAMPLE.trim());
    if (m) return { pre: m[1], th: m[2], dec: m[3], post: m[4] };
    try { var nf = new Intl.NumberFormat('en-GB', { style: 'currency', currency: CUR }); return { intl: nf }; } catch (e) { return { pre: '£', th: ',', dec: '.', post: '' }; }
  })();
  var money = function (p) {
    if (FMT.intl) return FMT.intl.format(p / 100);
    var neg = p < 0, v = Math.abs(Math.round(p)), whole = Math.floor(v / 100), frac = String(v % 100);
    if (frac.length < 2) frac = '0' + frac;
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, FMT.th);
    return (neg ? '−' : '') + FMT.pre + w + FMT.dec + frac + FMT.post;
  };
  var toP = function (n) { return Math.round(Number(n) * 100); };
  var show = function (el, on) { if (el) el.hidden = !on; };
  var debounce = function (fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; };

  /* ---------------- Draft storage ---------------- */
  var DB_NAME = 'adro-designs', STORE = 'art';
  function openDb() {
    return new Promise(function (res, rej) {
      if (!('indexedDB' in window)) { rej(new Error('no-idb')); return; }
      var r;
      try { r = indexedDB.open(DB_NAME, 1); } catch (e) { rej(e); return; }
      r.onupgradeneeded = function () { r.result.createObjectStore(STORE); };
      r.onsuccess = function () { res(r.result); };
      r.onerror = function () { rej(r.error); };
    });
  }
  function idbPut(k, v) {
    return openDb().then(function (db) {
      return new Promise(function (res, rej) {
        var t = db.transaction(STORE, 'readwrite'); t.objectStore(STORE).put(v, k);
        t.oncomplete = function () { res(true); }; t.onerror = t.onabort = function () { rej(t.error); };
      });
    });
  }
  function idbGet(k) {
    return openDb().then(function (db) {
      return new Promise(function (res, rej) {
        var q = db.transaction(STORE, 'readonly').objectStore(STORE).get(k);
        q.onsuccess = function () { res(q.result); }; q.onerror = function () { rej(q.error); };
      });
    });
  }
  function idbDel(k) {
    return openDb().then(function (db) {
      return new Promise(function (res) {
        var t = db.transaction(STORE, 'readwrite'); t.objectStore(STORE).delete(k);
        t.oncomplete = function () { res(true); }; t.onerror = function () { res(false); };
      });
    }).catch(function () { return false; });
  }
  var ls = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) { /* ignore */ } }
  };

  /* ---------------- Artwork processing ---------------- */
  var OK_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'];
  var OK_EXT = /\.(png|jpe?g|webp|svg)$/i;

  function loadImage(blob) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(blob);
      var img = new Image();
      img.onload = function () { res({ img: img, url: url }); };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error('decode')); };
      img.src = url;
    });
  }

  // Turns any artwork into a single-colour silver engraving on a transparent background, cropped to the artwork.
  function engrave(blob, invertPref) {
    return loadImage(blob).then(function (o) {
      var img = o.img;
      var isSvg = /svg/.test(blob.type || '') || /\.svg$/i.test(blob.name || '');
      var w = img.naturalWidth || 1000, h = img.naturalHeight || 1000;
      var srcLong = Math.max(w, h);
      var target = 1200;
      var k = isSvg ? target / srcLong : Math.min(1, target / srcLong);
      var cw = Math.max(1, Math.round(w * k)), ch = Math.max(1, Math.round(h * k));
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, cw, ch);
      URL.revokeObjectURL(o.url);
      var px;
      try { px = x.getImageData(0, 0, cw, ch).data; } catch (e) { throw new Error('decode'); }

      // Transparency and border sampling
      var n = cw * ch, clear = 0, samples = 0;
      for (var i = 3; i < px.length; i += 32) { samples++; if (px[i] < 245) clear++; }
      var useAlpha = clear / samples > 0.02;
      var borderLum = 0, bc = 0;
      var addB = function (xx, yy) { var j = (yy * cw + xx) * 4; borderLum += (0.2126 * px[j] + 0.7152 * px[j + 1] + 0.0722 * px[j + 2]) / 255; bc++; };
      for (var bx = 0; bx < cw; bx += Math.max(1, Math.floor(cw / 60))) { addB(bx, 0); addB(bx, ch - 1); }
      for (var by = 0; by < ch; by += Math.max(1, Math.floor(ch / 60))) { addB(0, by); addB(cw - 1, by); }
      borderLum = bc ? borderLum / bc : 1;
      var autoInvert = !useAlpha && borderLum < 0.45;
      var invert = invertPref === 'auto' || invertPref == null ? autoInvert : !!invertPref;

      var mask = new Float32Array(n);
      var minX = cw, minY = ch, maxX = -1, maxY = -1;
      for (var p = 0, q = 0; p < n; p++, q += 4) {
        var a = px[q + 3] / 255;
        var lum = (0.2126 * px[q] + 0.7152 * px[q + 1] + 0.0722 * px[q + 2]) / 255;
        var m;
        if (useAlpha) {
          m = a;
          if (invert) m = a * lum; // light artwork on transparency
        } else {
          m = invert ? lum : 1 - lum;
          m = (m - 0.12) / 0.76;
        }
        m = m < 0.06 ? 0 : (m > 1 ? 1 : m);
        mask[p] = m;
        if (m > 0.12) {
          var xx = p % cw, yy = (p - xx) / cw;
          if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
          if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
        }
      }
      if (maxX < 0) { var err = new Error('empty'); throw err; }

      var pad = Math.round(Math.max(maxX - minX, maxY - minY) * 0.02);
      minX = Math.max(0, minX - pad); minY = Math.max(0, minY - pad);
      maxX = Math.min(cw - 1, maxX + pad); maxY = Math.min(ch - 1, maxY + pad);
      var ow = maxX - minX + 1, oh = maxY - minY + 1;
      var out = document.createElement('canvas'); out.width = ow; out.height = oh;
      var ox = out.getContext('2d');
      var od = ox.createImageData(ow, oh), d = od.data;
      for (var y2 = 0; y2 < oh; y2++) {
        var t = y2 / Math.max(1, oh - 1);
        var base = 0.8 + 0.12 * Math.cos(t * Math.PI * 2.1) + 0.05 * Math.sin(t * 17);
        for (var x2 = 0; x2 < ow; x2++) {
          var mm = mask[(y2 + minY) * cw + (x2 + minX)];
          var k2 = (y2 * ow + x2) * 4;
          var grain = ((x2 * 73856093 ^ y2 * 19349663) & 255) / 255 * 0.06 - 0.03;
          var v = Math.max(0, Math.min(1, base + grain));
          d[k2] = v * 236; d[k2 + 1] = v * 238; d[k2 + 2] = v * 242; d[k2 + 3] = mm * 250;
        }
      }
      ox.putImageData(od, 0, 0);
      return {
        url: out.toDataURL('image/png'), w: ow, h: oh,
        srcW: w, srcH: h, lowRes: !isSvg && srcLong < 400, invert: invert, autoInvert: autoInvert
      };
    });
  }

  function cleanText(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  var TEXT_OK = /^[A-Za-z0-9À-ÖØ-öø-ÿ .,'’&\-!?#+\/()]*$/;

  var clamp = function (v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); };
  // Rotation helpers (degrees, kept between -180 and 180)
  var normDeg = function (d) { d = ((d % 360) + 540) % 360 - 180; return Math.abs(d) < 0.05 ? 0 : d; };
  var fmtDeg = function (d) { d = Math.round(normDeg(d || 0)); return (d < 0 ? '−' + (-d) : String(d)) + '°'; };
  var pct = function (n) { return (Math.round(n * 1000) / 1000) + '%'; };
  var measureCtx = null;
  function measureText(str, size) {
    if (!measureCtx) measureCtx = document.createElement('canvas').getContext('2d');
    measureCtx.font = '600 ' + size + 'px Inter, system-ui, -apple-system, sans-serif';
    return measureCtx.measureText(str).width + size * 0.06 * Math.max(0, str.length - 1);
  }
  function loadImg(src) {
    return new Promise(function (res, rej) {
      var im = new Image();
      im.onload = function () { res(im); };
      im.onerror = function () { rej(new Error('img')); };
      im.src = src;
    });
  }

  /* ---------------- Customiser ---------------- */
  var SIDES = ['logo', 'adro'];
  var SIDE_NAME = { logo: 'Your logo side', adro: 'ADRO logo side' };

  function Customiser(scope) {
    this.scope = scope;
    this.root = $('[data-cz]', scope);
    this.cfg = JSON.parse($('[data-cz-config]', this.root).textContent);
    this.g = this.cfg.geo;
    this.mode = this.cfg.mode;
    this.key = 'adro:design:' + this.mode;
    this.file = null;
    this.art = null;       // processed silver artwork { url, w, h, ... }
    this.artImg = null;    // loaded <img> of art for canvas
    this.example = null;   // processed example logo (never submitted)
    this.state = this.blank();
    this.listeners = [];
    this.u = 1;
    var q = function (s) { return $(s, scope); };
    this.el = {
      stage: q('[data-cz-stage]'), viewport: q('[data-cz-viewport]'), photo: q('[data-cz-photo]'),
      bg: q('[data-cz-bg]'), img: q('[data-cz-img]'), bound: q('[data-cz-bound]'), layer: q('[data-cz-layer]'),
      tools: q('[data-cz-tools]'), readout: q('[data-cz-readout]'), rotGroup: q('[data-cz-rot-group]'), rotReadout: q('[data-cz-rot-readout]'), angle: q('[data-cz-angle]'), hintline: q('[data-cz-hintline]'), live: q('[data-cz-live]'),
      sidehelp: q('[data-cz-sidehelp]'), chip: q('[data-cz-example-chip]'), zoom: q('[data-cz-zoom]'), zoomLabel: q('[data-cz-zoom-label]'),
      file: q('[data-cz-file]'), drop: q('[data-cz-drop]'), info: q('[data-cz-logo-info]'), thumb: q('[data-cz-logo-thumb]'),
      fname: q('[data-cz-logo-name]'), logoMsg: q('[data-cz-msg-logo]'), logoAdjust: q('[data-cz-logo-adjust]'), invert: q('[data-cz-invert]'),
      textInput: q('[data-cz-text-input]'), textCount: q('[data-cz-text-count]'), textMsg: q('[data-cz-msg-text]'), textAdjust: q('[data-cz-text-adjust]'),
      namesToggle: q('[data-q-names]'), namesWrap: q('[data-cz-names-wrap]'), namesCount: q('[data-cz-names-count]'),
      namesEach: q('[data-cz-names-each]'), namesSameWrap: q('[data-cz-names-same-wrap]'), namesSame: q('[data-cz-names-same]'), namesSameNote: q('[data-cz-names-same-note]'),
      namesEachWrap: q('[data-cz-names-each-wrap]'), namesList: q('[data-cz-names-list]'), namesAdd: q('[data-cz-names-add]'), namesAdd10: q('[data-cz-names-add10]'),
      namesPaste: q('[data-cz-names-paste]'), namesPasteGo: q('[data-cz-names-paste-go]'), namesLimit: q('[data-cz-names-limit]'),
      namesMsg: q('[data-cz-msg-names]'), status: q('[data-cz-status]'), reset: q('[data-cz-reset]'), restored: q('[data-cz-restored]')
    };
    this.save = debounce(this._save.bind(this), 350);
    this.reviewSoon = debounce(this.renderReview.bind(this), 180);
    this.announce = debounce(function (m) { if (this.el.live) this.el.live.textContent = m; }.bind(this), 450);
    this.setupPhoto();
    this.buildObjects();
    this.bind();
    this.render();
    var self = this;
    this.makeExample().then(function () { self.render(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.render(); });
    this.restore();
  }

  Customiser.prototype.blank = function () {
    return { v: 2, side: 'logo', logo: null, text: '', textPos: null, namesOn: false, namesEach: false, sameName: '', entries: [], qty: null };
  };
  Customiser.prototype.on = function (fn) { this.listeners.push(fn); };
  Customiser.prototype.emit = function () { var s = this.summary(); this.listeners.forEach(function (fn) { fn(s); }); };

  /* ----- geometry (all in source-photo pixels) ----- */
  Customiser.prototype.body = function (side) {
    var b = this.g.body, c = this.g.crop;
    if (side === 'logo') return { x: 2 * c.x + c.w - (b.x + b.w), y: b.y, w: b.w, h: b.h }; // photo is mirrored on the logo side
    return { x: b.x, y: b.y, w: b.w, h: b.h };
  };
  Customiser.prototype.area = function (side) {
    var b = this.body(side), a = side === 'logo' ? this.cfg.logoArea : this.cfg.textArea;
    var w = b.w * a.w / 100, h = b.h * a.h / 100, y = b.y + b.h * a.top / 100;
    if (side === 'adro') h = Math.min(h, this.g.mark.y - 8 - y); // keep initials clear of the ADRO logo
    return { x: b.x + (b.w - w) / 2, y: y, w: w, h: Math.max(20, h) };
  };
  Customiser.prototype.box = function (x, y, w, h) {
    var c = this.g.crop;
    return { left: pct((x - c.x) / c.w * 100), top: pct((y - c.y) / c.h * 100), width: pct(w / c.w * 100), height: pct(h / c.h * 100) };
  };
  Customiser.prototype.applyBox = function (el, b) { el.style.left = b.left; el.style.top = b.top; el.style.width = b.width; el.style.height = b.height; };

  Customiser.prototype.setupPhoto = function () {
    var g = this.g, c = g.crop, el = this.el, self = this;
    if (!el.photo) return;
    el.photo.style.aspectRatio = c.w + ' / ' + c.h;
    if (el.img) {
      el.img.style.width = pct(g.img.w / c.w * 100);
      el.img.style.left = pct(-c.x / c.w * 100);
      el.img.style.top = pct(-c.y / c.h * 100);
    }
    // Patches copy plain bottle surface over the ADRO logo (logo side) and over the loose lid touching the bottle edge.
    this.patchEls = [];
    if (el.img) (g.patches || []).forEach(function (pt) {
      var sp = document.createElement('span'); sp.className = 'cz-photo__patch';
      var pi = document.createElement('img'); pi.src = el.img.getAttribute('src'); pi.alt = ''; pi.setAttribute('draggable', 'false');
      sp.appendChild(pi);
      self.applyBox(sp, self.box(pt.x, pt.y, pt.w, pt.h));
      pi.style.width = pct(g.img.w / pt.w * 100);
      pi.style.left = pct(-pt.x / pt.w * 100);
      pi.style.top = pct(-pt.fromY / pt.h * 100);
      el.img.parentNode.insertBefore(sp, el.img.nextSibling);
      self.patchEls.push({ el: sp, logoOnly: !!pt.logoOnly });
    });
    var cov = $('.cz-photo__cover', el.photo);
    if (cov) this.applyBox(cov, this.box(g.cover.x, g.cover.y, g.cover.w, g.cover.h));
    this.cleanPhoto();
    var measure = function () {
      var w = el.photo.offsetWidth || 1;
      self.u = w / c.w;
      el.photo.style.setProperty('--u', self.u + 'px');
    };
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(el.photo);
    else window.addEventListener('resize', measure);
  };

  Customiser.prototype.buildObjects = function () {
    var mk = function (cls, interactive) {
      var d = document.createElement('div');
      d.className = cls;
      d.innerHTML = '<img class="cz-obj__img" alt="" draggable="false" hidden><span class="cz-obj__text" hidden></span>';
      if (interactive) {
        d.tabIndex = 0;
        d.setAttribute('role', 'group');
        d.setAttribute('aria-roledescription', 'movable artwork');
        ['nw', 'ne', 'sw', 'se', 'rot'].forEach(function (h) {
          var s = document.createElement('span'); s.className = 'cz-obj__h cz-obj__h--' + h; s.setAttribute('data-h', h); s.setAttribute('aria-hidden', 'true'); d.appendChild(s);
        });
      } else d.setAttribute('aria-hidden', 'true');
      return d;
    };
    this.objEl = mk('cz-obj', true);
    this.exEl = mk('cz-obj cz-obj--example', false);
    this.el.layer.appendChild(this.exEl);
    this.el.layer.appendChild(this.objEl);
  };

  /* ----- design data ----- */
  // Names are kept exactly as typed (spelling and capitalisation); only surrounding and repeated spaces are tidied.
  Customiser.prototype.nameList = function () {
    var st = this.state;
    if (this.mode !== 'bulk' || !st.namesOn) return [];
    if (st.namesEach) return (st.entries || []).map(cleanText).filter(Boolean);
    var one = cleanText(st.sameName);
    return one ? [one] : [];
  };
  Customiser.prototype.namesInfo = function () {
    var st = this.state, q = st.qty || 0, max = this.cfg.maxText;
    var info = { on: !!st.namesOn, each: !!st.namesEach, qty: q, same: cleanText(st.sameName), filled: [], unassigned: [], invalid: [], tooLong: [], over: 0, fields: 0 };
    if (!info.on) return info;
    if (!info.each) {
      if (info.same && !TEXT_OK.test(info.same)) info.invalid.push(1);
      if (info.same.length > max) info.tooLong.push(1);
      info.bottles = q; info.assigned = info.same ? q : 0;
      info.block = info.invalid.length > 0 || info.tooLong.length > 0;
      return info;
    }
    var entries = st.entries || [];
    info.fields = entries.length;
    entries.forEach(function (raw, i) {
      var t = cleanText(raw), n = i + 1;
      if (t) {
        info.filled.push({ n: n, text: t });
        if (!TEXT_OK.test(t)) info.invalid.push(n);
        if (t.length > max) info.tooLong.push(n);
      }
    });
    var have = {};
    info.filled.forEach(function (f) { if (f.n <= q) have[f.n] = true; });
    for (var b = 1; b <= q; b++) if (!have[b]) info.unassigned.push(b);
    info.over = Math.max(0, entries.length - q);
    info.overFilled = info.filled.filter(function (f) { return f.n > q; }).length;
    info.assigned = info.filled.length - info.overFilled;
    info.bottles = info.assigned;
    info.block = info.over > 0 || info.invalid.length > 0 || info.tooLong.length > 0;
    return info;
  };
  Customiser.prototype.previewText = function () {
    if (this.mode === 'single') return cleanText(this.state.text);
    if (!this.state.namesOn) return '';
    var list = this.nameList(), best = '';
    var max = this.cfg.maxText;
    list.forEach(function (n) { if (n.length <= max && TEXT_OK.test(n) && measureText(n, 20) > measureText(best, 20)) best = n; });
    return best;
  };
  Customiser.prototype.summary = function () {
    var st = this.state;
    var hasLogo = !!(st.logo && this.art);
    var text = cleanText(st.text);
    var names = this.mode === 'bulk' ? this.nameList() : [];
    var hasText = this.mode === 'single' ? (!!text && TEXT_OK.test(text)) : (st.namesOn && names.length > 0);
    return {
      mode: this.mode, hasLogo: hasLogo, hasText: hasText, text: text, textValid: !text || TEXT_OK.test(text),
      namesOn: !!st.namesOn, names: names, namesInfo: this.mode === 'bulk' ? this.namesInfo() : null, logo: st.logo, file: this.file,
      logoPlacement: hasLogo ? this.describe('logo') : '', textPlacement: (hasText || (st.namesOn && names.length)) ? this.describe('adro') : ''
    };
  };
  Customiser.prototype.userHas = function () {
    var s = this.summary();
    var typed = this.mode === 'single' ? !!s.text : s.names.length > 0;
    return { logo: s.hasLogo, adro: typed, any: s.hasLogo || typed };
  };
  Customiser.prototype.exampleOn = function (side) {
    var u = this.userHas();
    if (u[side]) return false;
    if (!u.any) return true;
    return this.mode === 'bulk' && side === 'adro' && this.state.namesOn;
  };

  // The editable object on a side, with its stored (desired) position.
  Customiser.prototype.objFor = function (side) {
    var st = this.state;
    if (side === 'logo' && st.logo && this.art) {
      if (st.logo.x == null) this.defaultPos('logo', st.logo, this.art.w / this.art.h);
      return { kind: 'logo', side: side, pos: st.logo, aspect: this.art.w / this.art.h };
    }
    if (side === 'adro') {
      var t = this.previewText();
      if (t) {
        if (!st.textPos) { st.textPos = {}; this.defaultPos('adro', st.textPos, null, t); }
        return { kind: 'text', side: side, pos: st.textPos, text: t };
      }
    }
    return null;
  };
  Customiser.prototype.defaultPos = function (side, pos, aspect, text) {
    var a = this.area(side), b = this.body(side);
    if (side === 'logo') {
      pos.s = Math.min(a.w * 0.8, a.h * 0.5 * aspect);
      pos.x = a.x + a.w / 2; pos.y = a.y + a.h * 0.42;
    } else {
      pos.s = 15; pos.x = a.x + a.w / 2; pos.y = a.y + a.h * 0.5;
    }
  };
  Customiser.prototype.sizeOf = function (obj, s) {
    if (obj.kind === 'logo') return { w: s, h: s / obj.aspect };
    return { w: Math.max(1, measureText(obj.text, s)), h: s * 1.2 };
  };
  // Where the object actually sits: never outside the engraving area, never cropped.
  // Rotated objects are kept inside the area using their rotated bounding box.
  Customiser.prototype.effective = function (obj) {
    var a = this.area(obj.side), p = obj.pos, s = p.s, clampedSize = false, clampedPos = false;
    var r = obj.kind === 'logo' ? normDeg(p.r || 0) : 0, rad = r * Math.PI / 180, cs = Math.abs(Math.cos(rad)), sn = Math.abs(Math.sin(rad));
    var bound = function (sz) { return { w: sz.w * cs + sz.h * sn, h: sz.w * sn + sz.h * cs }; };
    var sz = this.sizeOf(obj, s), bb = bound(sz);
    var k = Math.min(a.w / bb.w, a.h / bb.h);
    if (k < 1) { s = s * k * 0.999; sz = this.sizeOf(obj, s); bb = bound(sz); clampedSize = true; }
    var minS = obj.kind === 'logo' ? a.w * 0.18 : 9;
    if (s < minS && !clampedSize) { s = minS; sz = this.sizeOf(obj, s); bb = bound(sz); } // long names and rotated logos shrink to fit rather than overflow
    var x = clamp(p.x, a.x + bb.w / 2, a.x + a.w - bb.w / 2);
    var y = clamp(p.y, a.y + bb.h / 2, a.y + a.h - bb.h / 2);
    if (Math.abs(x - p.x) > 0.01 || Math.abs(y - p.y) > 0.01) clampedPos = true;
    return { x: x, y: y, s: s, w: sz.w, h: sz.h, bw: bb.w, bh: bb.h, r: r, clampedSize: clampedSize, clampedPos: clampedPos, area: a };
  };
  Customiser.prototype.describe = function (side) {
    var obj = this.objFor(side); if (!obj) return '';
    var e = this.effective(obj), a = e.area;
    var w = Math.round(e.w / a.w * 100), cx = Math.round((e.x - a.x) / a.w * 100), cy = Math.round((e.y - a.y) / a.h * 100);
    return w + '% of engraving-area width, centre ' + cx + '% across and ' + cy + '% down the area' + (e.r ? ', rotated ' + fmtDeg(e.r) + (e.r > 0 ? ' clockwise' : ' anticlockwise') : '');
  };
  Customiser.prototype.shortDescribe = function (obj) {
    var e = this.effective(obj), a = e.area;
    var cx = Math.round((e.x - a.x) / a.w * 100), cy = Math.round((e.y - a.y) / a.h * 100);
    var where = (Math.abs(cx - 50) <= 2 ? 'centred' : (cx < 50 ? (50 - cx) + '% left of centre' : (cx - 50) + '% right of centre'));
    where += ', ' + (Math.abs(cy - 50) <= 2 ? 'middle' : (cy < 50 ? (50 - cy) + '% above middle' : (cy - 50) + '% below middle'));
    return (obj.kind === 'logo' ? 'Logo' : 'Text') + ' ' + Math.round(e.w / a.w * 100) + '% of area width, ' + where + (e.r ? ', rotated ' + fmtDeg(e.r) : '') + '.';
  };

  /* ----- events ----- */
  Customiser.prototype.bind = function () {
    var self = this, el = this.el;
    $$('[data-cz-side]', this.scope).forEach(function (b) {
      b.addEventListener('click', function () { self.setSide(b.getAttribute('data-cz-side'), true); });
    });
    if (el.zoom) el.zoom.addEventListener('click', function () { self.setZoom(!el.viewport.classList.contains('is-zoomed')); });
    $$('[data-cz-act]', this.scope).forEach(function (b) {
      b.addEventListener('click', function () { self.act(b.getAttribute('data-cz-act')); });
    });

    // Drag to move, drag a corner to resize
    var o = this.objEl, drag = null;
    o.addEventListener('pointerdown', function (e) {
      var obj = self.objFor(self.state.side); if (!obj) return;
      if (e.button != null && e.button !== 0) return;
      e.preventDefault();
      try { o.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      o.focus({ preventScroll: true });
      var r = el.photo.getBoundingClientRect(), c = self.g.crop, eff = self.effective(obj);
      obj.pos.x = eff.x; obj.pos.y = eff.y; obj.pos.s = eff.s;
      var h = e.target.getAttribute && e.target.getAttribute('data-h');
      if (h === 'rot' && obj.kind !== 'logo') h = null;
      drag = { id: e.pointerId, obj: obj, k: c.w / r.width, sx: e.clientX, sy: e.clientY, x0: eff.x, y0: eff.y, s0: eff.s, r0: eff.r, resize: !!h && h !== 'rot', rotate: h === 'rot' };
      if (h) {
        drag.cx = r.left + (eff.x - c.x) / c.w * r.width; drag.cy = r.top + (eff.y - c.y) / c.h * r.height;
        drag.d0 = Math.max(8, Math.hypot(e.clientX - drag.cx, e.clientY - drag.cy));
        drag.a0 = Math.atan2(e.clientY - drag.cy, e.clientX - drag.cx) * 180 / Math.PI;
      }
      if (drag.rotate) el.stage.classList.add('is-rotating');
      el.stage.classList.add('is-dragging');
    });
    o.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var p = drag.obj.pos;
      if (drag.rotate) {
        var ang = normDeg(drag.r0 + Math.atan2(e.clientY - drag.cy, e.clientX - drag.cx) * 180 / Math.PI - drag.a0);
        if (e.shiftKey) ang = Math.round(ang / 15) * 15;
        else if (Math.abs(ang) < 3) ang = 0; // gentle snap to straight
        p.r = Math.round(ang);
      } else if (drag.resize) p.s = drag.s0 * Math.hypot(e.clientX - drag.cx, e.clientY - drag.cy) / drag.d0;
      else { p.x = drag.x0 + (e.clientX - drag.sx) * drag.k; p.y = drag.y0 + (e.clientY - drag.sy) * drag.k; }
      var eff = self.effective(drag.obj);
      el.stage.classList.toggle('is-edge', eff.clampedPos || eff.clampedSize);
      p.x = eff.x; p.y = eff.y; p.s = eff.s;
      self.renderObjects();
    });
    var end = function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var obj = drag.obj; drag = null;
      el.stage.classList.remove('is-dragging', 'is-edge', 'is-rotating');
      self.changed();
      self.announce(self.shortDescribe(obj));
    };
    o.addEventListener('pointerup', end);
    o.addEventListener('pointercancel', end);
    o.addEventListener('keydown', function (e) {
      var map = { ArrowLeft: 'left', ArrowRight: 'right', ArrowUp: 'up', ArrowDown: 'down', '+': 'larger', '=': 'larger', '-': 'smaller', '_': 'smaller', c: 'centre', C: 'centre', '[': 'rotl', ']': 'rotr', r: 'rot0', R: 'rot0' };
      var a = map[e.key]; if (!a) return;
      e.preventDefault();
      self.act(a, e.shiftKey ? 4 : 1);
    });
    o.addEventListener('focus', function () { el.stage.classList.add('is-focus'); });
    o.addEventListener('blur', function () { el.stage.classList.remove('is-focus'); });

    if (el.file) {
      el.file.addEventListener('change', function () { if (el.file.files[0]) self.useFile(el.file.files[0], true); el.file.value = ''; });
      ['dragenter', 'dragover'].forEach(function (ev) { el.drop.addEventListener(ev, function (e) { e.preventDefault(); el.drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { el.drop.addEventListener(ev, function (e) { e.preventDefault(); el.drop.classList.remove('is-over'); }); });
      el.drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files[0]; if (f) self.useFile(f, true); });
      $('[data-cz-logo-replace]', this.scope).addEventListener('click', function () { el.file.click(); });
      $('[data-cz-logo-remove]', this.scope).addEventListener('click', function () { self.removeLogo(); });
      el.invert.addEventListener('change', function () { self.state.logo.invert = el.invert.checked; self.reprocess(); });
    }
    if (el.textInput) {
      el.textInput.addEventListener('focus', function () { self.setSide('adro'); });
      el.textInput.addEventListener('input', function () { self.state.text = el.textInput.value; self.setSide('adro'); self.changed(); });
    }
    if (el.namesToggle) {
      el.namesToggle.addEventListener('change', function () { self.state.namesOn = el.namesToggle.checked; if (self.state.namesOn) self.setSide('adro'); self.changed(); });
      el.namesSame.addEventListener('focus', function () { self.setSide('adro'); });
      el.namesSame.addEventListener('input', function () { self.state.sameName = el.namesSame.value; self.changed(); });
      el.namesEach.addEventListener('change', function () {
        var st = self.state;
        st.namesEach = el.namesEach.checked;
        if (st.namesEach && !(st.entries || []).length) {
          // Start with a few empty fields. Nothing is copied across automatically.
          st.entries = []; var start = Math.min(3, Math.max(1, st.qty || 1));
          for (var i = 0; i < start; i++) st.entries.push('');
        }
        self.renderNameFields(); self.setSide('adro'); self.changed();
      });
      el.namesList.addEventListener('focusin', function () { self.setSide('adro'); });
      el.namesList.addEventListener('input', function (e) {
        var i = e.target.getAttribute('data-n'); if (i == null) return;
        self.state.entries[+i] = e.target.value; self.changed();
      });
      el.namesList.addEventListener('click', function (e) {
        var b = e.target.closest('[data-n-remove]'); if (!b) return;
        var i = +b.getAttribute('data-n-remove');
        self.state.entries.splice(i, 1);
        self.renderNameFields(); self.changed();
        var inputs = $$('[data-n]', el.namesList), next = inputs[Math.min(i, inputs.length - 1)];
        if (next) next.focus(); else el.namesAdd.focus();
        self.announce('Entry removed. Later bottles have moved up one number.');
      });
      var addN = function (n) {
        var st = self.state, room = Math.max(0, (st.qty || 0) - st.entries.length), k = Math.min(n, room);
        if (!k) { self.renderNamesStatus(); return; }
        var first = st.entries.length;
        for (var i = 0; i < k; i++) st.entries.push('');
        self.renderNameFields(); self.changed();
        var f = $('[data-n="' + first + '"]', el.namesList); if (f) f.focus();
      };
      el.namesAdd.addEventListener('click', function () { addN(1); });
      el.namesAdd10.addEventListener('click', function () { addN(10); });
      el.namesPasteGo.addEventListener('click', function () {
        var lines = el.namesPaste.value.split(/\r?\n/).map(function (l) { return l.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
        if (!lines.length) { self.announce('Nothing to add. Paste one name per line.'); return; }
        var st = self.state;
        while (st.entries.length && !cleanText(st.entries[st.entries.length - 1])) st.entries.pop();
        var from = st.entries.length + 1;
        st.entries = st.entries.concat(lines);
        el.namesPaste.value = '';
        self.renderNameFields(); self.changed();
        self.announce('Added ' + lines.length + (lines.length === 1 ? ' entry' : ' entries') + ' for bottles ' + from + '–' + (from + lines.length - 1) + '.');
      });
    }
    if (el.reset) el.reset.addEventListener('click', function () { self.resetDesign(); });
    window.addEventListener('pagehide', function () { self._save(); });
  };

  Customiser.prototype.act = function (a, mult) {
    var obj = this.objFor(this.state.side); if (!obj) return;
    mult = mult || 1;
    var p = obj.pos, before = this.effective(obj), stepXY = 3 * mult;
    p.x = before.x; p.y = before.y; p.s = before.s;
    if (a === 'smaller') p.s *= Math.pow(0.93, mult);
    else if (a === 'larger') p.s *= Math.pow(1.07, mult);
    else if (a === 'left') p.x -= stepXY;
    else if (a === 'right') p.x += stepXY;
    else if (a === 'up') p.y -= stepXY;
    else if (a === 'down') p.y += stepXY;
    else if (a === 'centre') { var ar = before.area; p.x = ar.x + ar.w / 2; if (obj.kind === 'logo') p.y = ar.y + ar.h / 2; }
    else if (/^rot/.test(a)) {
      if (obj.kind !== 'logo') return;
      p.r = a === 'rot0' ? 0 : normDeg((before.r || 0) + (a === 'rotl' ? -5 : 5) * mult);
      this.changed(); this.flashAngle();
      this.announce('Logo rotated ' + fmtDeg(p.r) + '.');
      return;
    }
    var eff = this.effective(obj);
    var stuck = (a === 'larger' && eff.s <= before.s + 0.01) || (/left|right|up|down/.test(a) && Math.abs(eff.x - before.x) < 0.01 && Math.abs(eff.y - before.y) < 0.01);
    p.x = eff.x; p.y = eff.y; p.s = eff.s;
    this.changed();
    if (stuck) this.hint(a === 'larger' ? 'That’s the largest size that fits inside the engraving area.' : 'That’s the edge of the engraving area.');
    this.announce((stuck ? (a === 'larger' ? 'Largest size that fits. ' : 'At the edge of the engraving area. ') : '') + this.shortDescribe(obj));
  };
  // Show the rotation angle on the preview while it changes.
  Customiser.prototype.flashAngle = function () {
    var el = this.el; if (!el.angle) return;
    el.angle.hidden = false; el.angle.classList.add('is-on');
    clearTimeout(this._angT); this._angT = setTimeout(function () { el.angle.classList.remove('is-on'); }, 1400);
  };
  Customiser.prototype.hint = function (msg) {
    var h = this.el.hintline; if (!h) return;
    h.textContent = msg; h.classList.add('is-on');
    clearTimeout(this._hintT); this._hintT = setTimeout(function () { h.classList.remove('is-on'); h.textContent = ''; }, 2600);
  };
  Customiser.prototype.setZoom = function (on) {
    var el = this.el; if (!el.viewport) return;
    el.viewport.classList.toggle('is-zoomed', on);
    el.zoom.setAttribute('aria-pressed', String(on));
    el.zoomLabel.textContent = on ? 'Zoom out' : 'Zoom in';
    this.updateZoomOrigin();
  };
  Customiser.prototype.updateZoomOrigin = function () {
    var a = this.area(this.state.side), c = this.g.crop;
    this.el.photo.style.transformOrigin = pct((a.x + a.w / 2 - c.x) / c.w * 100) + ' ' + pct((a.y + a.h / 2 - c.y) / c.h * 100);
  };

  Customiser.prototype.setSide = function (side, announce) {
    if (side === 'front') side = 'logo';
    if (side === 'back') side = 'adro';
    if (SIDES.indexOf(side) < 0) return;
    var changedSide = this.state.side !== side;
    this.state.side = side;
    $$('[data-cz-side]', this.scope).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cz-side') === side)); });
    if (changedSide) {
      this.el.viewport.classList.remove('is-turn'); void this.el.viewport.offsetWidth; this.el.viewport.classList.add('is-turn');
    }
    this.renderStage();
    if (announce) this.announce('Showing ' + SIDE_NAME[side] + '.');
    this.save();
  };

  /* ----- artwork ----- */
  Customiser.prototype.logoMsg = function (msg, tone) {
    var m = this.el.logoMsg; if (!m) return;
    m.textContent = msg || ''; m.hidden = !msg; m.className = 'cz-msg' + (tone ? ' cz-msg--' + tone : '');
  };
  Customiser.prototype.setArt = function (art) {
    var self = this;
    this.art = art; this.artImg = null;
    if (!art) return Promise.resolve();
    return loadImg(art.url).then(function (im) { if (self.art === art) self.artImg = im; }).catch(function () { /* canvas review will skip */ });
  };
  Customiser.prototype.useFile = function (file, fresh) {
    var self = this, maxBytes = this.cfg.maxFileMb * 1024 * 1024;
    var okType = OK_TYPES.indexOf(file.type) > -1 || OK_EXT.test(file.name || '');
    if (!okType) { this.logoMsg('That file type can’t be engraved here. Please upload a PNG, JPG, SVG or WebP file.', 'error'); return Promise.resolve(false); }
    if (file.size > maxBytes) { this.logoMsg('That file is over ' + this.cfg.maxFileMb + ' MB. Please upload a smaller version.', 'error'); return Promise.resolve(false); }
    if (file.size === 0) { this.logoMsg('That file is empty. Please choose another.', 'error'); return Promise.resolve(false); }
    this.logoMsg('Preparing your preview…');
    var prev = this.state.logo;
    var invertPref = fresh ? 'auto' : (prev ? prev.invert : 'auto');
    return engrave(file, invertPref).then(function (art) {
      self.file = file;
      return self.setArt(art).then(function () {
        var keep = !fresh && prev && prev.x != null;
        self.state.logo = {
          name: file.name || 'artwork', type: file.type, size: file.size,
          invert: art.invert, srcW: art.srcW, srcH: art.srcH, lowRes: art.lowRes,
          remoteUrl: fresh ? null : (prev && prev.remoteUrl) || null,
          x: keep ? prev.x : null, y: keep ? prev.y : null, s: keep ? prev.s : null, r: keep ? (prev.r || 0) : 0
        };
        if (!keep) self.defaultPos('logo', self.state.logo, art.w / art.h);
        self.logoMsg(art.lowRes ? 'This image is quite small, so the engraving may look soft. A larger file or an SVG will engrave more crisply.' : '', art.lowRes ? 'warn' : '');
        if (fresh) { self._artDirty = true; self.setSide('logo'); self.announce('Logo added to your logo side. Drag it, or use the buttons under the bottle, to position it.'); }
        self.syncInputs();
        self.changed();
        return true;
      });
    }).catch(function (e) {
      if (e && e.message === 'empty') self.logoMsg('We couldn’t find any artwork in that image. Try a logo on a transparent or plain background.', 'error');
      else self.logoMsg('We couldn’t read that file. It may be damaged or in an unsupported format. Please try another.', 'error');
      return false;
    });
  };
  Customiser.prototype.reprocess = function () {
    if (!this.file) return;
    var self = this, pref = this.state.logo ? this.state.logo.invert : 'auto';
    engrave(this.file, pref).then(function (art) { return self.setArt(art).then(function () { self.state.logo.invert = art.invert; self.changed(); }); })
      .catch(function () { self.logoMsg('We couldn’t update the artwork. Please try again.', 'error'); });
  };
  Customiser.prototype.removeLogo = function () {
    this.file = null; this.setArt(null); this.state.logo = null; this._artDirty = true;
    this.logoMsg('');
    this.changed();
    this.announce('Logo removed.');
  };
  Customiser.prototype.makeExample = function () {
    var self = this;
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600"><rect x="30" y="30" width="540" height="540" fill="none" stroke="#000" stroke-width="22"/>' +
      '<text x="300" y="215" font-family="Arial,Helvetica,sans-serif" font-size="130" font-weight="700" text-anchor="middle" fill="#000">YOUR</text>' +
      '<text x="300" y="355" font-family="Arial,Helvetica,sans-serif" font-size="130" font-weight="700" text-anchor="middle" fill="#000">LOGO</text>' +
      '<text x="300" y="495" font-family="Arial,Helvetica,sans-serif" font-size="130" font-weight="700" text-anchor="middle" fill="#000">HERE</text></svg>';
    var blob = new Blob([svg], { type: 'image/svg+xml' }); blob.name = 'example.svg';
    return engrave(blob, false).then(function (art) { self.example = art; }).catch(function () { /* decorative */ });
  };

  /* ----- state change ----- */
  Customiser.prototype.changed = function () { this.render(); this.save(); this.emit(); };
  Customiser.prototype.syncInputs = function () {
    var st = this.state, el = this.el;
    if (el.invert && st.logo) el.invert.checked = !!st.logo.invert;
    if (el.textInput && el.textInput.value !== st.text) el.textInput.value = st.text;
    if (el.namesToggle) {
      el.namesToggle.checked = !!st.namesOn; el.namesEach.checked = !!st.namesEach;
      if (el.namesSame.value !== (st.sameName || '')) el.namesSame.value = st.sameName || '';
      this.renderNameFields();
    }
  };

  /* ----- rendering ----- */
  Customiser.prototype.renderObjects = function () {
    var side = this.state.side, o = this.objEl, ex = this.exEl, self = this;
    var place = function (node, kind, e, src, text) {
      var img = $('.cz-obj__img', node), span = $('.cz-obj__text', node);
      if (!kind) { node.hidden = true; return; }
      node.hidden = false;
      self.applyBox(node, self.box(e.x - e.w / 2, e.y - e.h / 2, e.w, e.h));
      node.style.transform = e.r ? 'rotate(' + e.r + 'deg)' : '';
      img.hidden = kind !== 'logo'; span.hidden = kind !== 'text';
      if (kind === 'logo') { if (img.getAttribute('src') !== src) img.src = src; }
      else { span.textContent = text; span.style.fontSize = 'calc(var(--u) * ' + e.s.toFixed(3) + ')'; }
    };
    var obj = this.objFor(side);
    if (obj) {
      var e = this.effective(obj);
      place(o, obj.kind, e, obj.kind === 'logo' ? this.art.url : null, obj.text);
      o.setAttribute('aria-label', (obj.kind === 'logo' ? 'Your logo' : (this.mode === 'bulk' ? 'Name preview' : 'Your initials')) +
        '. Drag to move, drag a corner to resize. Keyboard: arrow keys move, plus and minus resize, C re-centres.');
      if (this.el.readout) this.el.readout.textContent = Math.round(e.w / e.area.w * 100) + '%';
      var isLogo = obj.kind === 'logo';
      show(this.el.rotGroup, isLogo);
      o.classList.toggle('is-logo', isLogo);
      if (this.el.rotReadout) this.el.rotReadout.textContent = fmtDeg(isLogo ? e.r : 0);
      if (this.el.angle) this.el.angle.textContent = 'Rotation ' + fmtDeg(isLogo ? e.r : 0);
      if (isLogo && this.el.stage.classList.contains('is-rotating')) this.flashAngle();
    } else { place(o, null); show(this.el.rotGroup, false); }
    if (this.el.angle && !(obj && obj.kind === 'logo')) this.el.angle.classList.remove('is-on');

    var exKind = null, exE = null;
    if (this.exampleOn(side)) {
      if (side === 'logo' && this.example) {
        var a = this.area('logo'), asp = this.example.w / this.example.h, s = Math.min(a.w * 0.62, a.h * 0.45 * asp);
        exKind = 'logo'; exE = { x: a.x + a.w / 2, y: a.y + a.h * 0.42, w: s, h: s / asp, s: s };
      } else if (side === 'adro') {
        var t = this.cfg.exampleText, a2 = this.area('adro'), s2 = 15, w2 = measureText(t, s2);
        exKind = 'text'; exE = { x: a2.x + a2.w / 2, y: a2.y + a2.h * 0.5, w: w2, h: s2 * 1.2, s: s2 };
      }
    }
    place(ex, exKind, exE, exKind === 'logo' ? this.example.url : null, this.cfg.exampleText);
  };

  Customiser.prototype.renderStage = function () {
    var side = this.state.side, el = this.el, u = this.userHas();
    el.bg.classList.toggle('is-mirror', side === 'logo');
    (this.patchEls || []).forEach(function (p) { p.el.hidden = p.logoOnly && side !== 'logo'; });
    var a = this.area(side);
    this.applyBox(el.bound, this.box(a.x, a.y, a.w, a.h));
    this.updateZoomOrigin();
    var obj = this.objFor(side);
    el.stage.classList.toggle('has-obj', !!obj);
    show(el.tools, !!obj);
    show(el.chip, this.exampleOn(side));
    this.renderObjects();

    var help;
    if (side === 'logo') {
      help = u.logo ? 'Your logo side, opposite the ADRO logo. Drag to move, drag a corner to resize, or drag the round handle below it to rotate.'
        : (this.exampleOn('logo') ? 'Your logo side, opposite the ADRO logo. Upload a logo to replace the example.' : 'Your logo side: not engraved. Upload a logo to add one.');
    } else {
      var what = this.mode === 'bulk' ? 'names' : 'initials';
      if (u.adro) help = this.mode === 'bulk' ? (this.state.namesEach ? 'ADRO logo side. Previewing your longest name, “' + this.previewText() + '”. Every name uses this size and position.' : 'ADRO logo side. Your initials or name sit in the upper half, above the ADRO logo, on every bottle.') : 'ADRO logo side. Your initials sit in the upper half of the bottle, above the ADRO logo.';
      else if (this.exampleOn('adro')) help = 'ADRO logo side. ' + (this.mode === 'bulk' ? (this.state.namesOn ? 'Add names to replace the example.' : 'Optional initials or names go above the ADRO logo.') : 'Add initials to replace the example.');
      else help = 'ADRO logo side: no ' + what + '. The standard ADRO logo is always engraved here.';
    }
    el.sidehelp.textContent = help;
    SIDES.forEach(function (sd) {
      var tag = $('[data-cz-side-state="' + sd + '"]', this.scope);
      if (tag) tag.textContent = u[sd] ? '✓' : '';
    }, this);
  };

  Customiser.prototype.render = function () {
    var st = this.state, el = this.el;
    this.renderStage();
    if (el.info) {
      show(el.info, !!st.logo); show(el.drop, !st.logo); show(el.logoAdjust, !!st.logo);
      if (st.logo) { el.fname.textContent = st.logo.name; el.thumb.src = this.art ? this.art.url : ''; }
    }
    if (el.textInput) {
      var t = st.text || '';
      el.textCount.textContent = t.length + '/' + this.cfg.maxText;
      var bad = t && !TEXT_OK.test(cleanText(t));
      el.textMsg.hidden = !bad;
      el.textMsg.className = 'cz-msg cz-msg--error';
      el.textMsg.textContent = bad ? 'Some characters can’t be engraved. Please use letters, numbers and simple punctuation.' : '';
      el.textInput.setAttribute('aria-invalid', bad ? 'true' : 'false');
      show(el.textAdjust, !!cleanText(t));
    }
    if (el.namesToggle) this.renderNamesStatus();
    show(el.reset, this.userHas().any || !!st.namesOn);
    this.reviewSoon();
  };

  /* ----- composite images (review + order preview). Example artwork is never drawn. ----- */
  // The studio photo sits on a light grey floor that reads as a shadow under the bottle. Lift those pale grey pixels
  // below the bottle base to white (the black bottle and its highlights are untouched), then use the cleaned copy
  // for the on-screen preview and for the saved preview images.
  Customiser.prototype.cleanPhoto = function () {
    var self = this, g = this.g, c = g.crop, im = this.el.img, f = g.floor;
    if (!im || !f) return;
    var run = function () {
      if (self.cleanCanvas || !im.naturalWidth) return;
      try {
        var cv = document.createElement('canvas'); cv.width = g.img.w; cv.height = g.img.h;
        var x = cv.getContext('2d'); x.drawImage(im, 0, 0, g.img.w, g.img.h);
        var y0 = f.y, y1 = Math.min(g.img.h, c.y + c.h), x0 = c.x, x1 = Math.min(g.img.w, c.x + c.w);
        var data = x.getImageData(x0, y0, x1 - x0, y1 - y0), d = data.data;
        for (var i = 0; i < d.length; i += 4) {
          var r = d[i], gg = d[i + 1], b = d[i + 2], v = (r + gg + b) / 3, sat = Math.max(r, gg, b) - Math.min(r, gg, b);
          if (sat > 40 || v <= f.lo) continue;
          var t = v >= f.hi ? 1 : (v - f.lo) / (f.hi - f.lo);
          d[i] = r + (255 - r) * t; d[i + 1] = gg + (255 - gg) * t; d[i + 2] = b + (255 - b) * t;
        }
        x.putImageData(data, x0, y0);
        x.fillStyle = '#fff'; x.fillRect(x0, f.clear, x1 - x0, y1 - f.clear);
        if (g.cover) x.fillRect(g.cover.x, g.cover.y, g.cover.w, g.cover.h); // bake the cover in so no dark edge shows at the crop boundary
        self.cleanCanvas = cv;
        cv.toBlob(function (blob) {
          if (!blob) return;
          var url = URL.createObjectURL(blob);
          im.src = url;
          $$('.cz-photo__patch img', self.el.photo).forEach(function (pi) { pi.src = url; });
        }, 'image/png');
      } catch (e) { /* cross-origin or canvas unavailable: keep the original photo */ }
    };
    if (im.complete && im.naturalWidth) run(); else im.addEventListener('load', run, { once: true });
  };
  Customiser.prototype.photoReady = function () {
    if (this.cleanCanvas) return Promise.resolve(this.cleanCanvas);
    var im = this.el.img;
    if (!im) return Promise.reject(new Error('nophoto'));
    if (im.complete && im.naturalWidth) return Promise.resolve(im);
    return new Promise(function (res, rej) { im.addEventListener('load', function () { res(im); }, { once: true }); im.addEventListener('error', rej, { once: true }); });
  };
  Customiser.prototype.compose = function (side, scale) {
    var self = this, g = this.g, c = g.crop;
    return this.photoReady().then(function (photo) {
      var cv = document.createElement('canvas'); cv.width = Math.round(c.w * scale); cv.height = Math.round(c.h * scale);
      var x = cv.getContext('2d');
      x.fillStyle = '#fff'; x.fillRect(0, 0, cv.width, cv.height);
      x.save();
      if (side === 'logo') { x.translate(cv.width, 0); x.scale(-1, 1); }
      x.drawImage(photo, c.x, c.y, c.w, c.h, 0, 0, cv.width, cv.height);
      (g.patches || []).forEach(function (pt) {
        if (pt.logoOnly && side !== 'logo') return;
        x.drawImage(photo, pt.x, pt.fromY, pt.w, pt.h, (pt.x - c.x) * scale, (pt.y - c.y) * scale, pt.w * scale, pt.h * scale);
      });
      x.fillStyle = '#fff'; x.fillRect((g.cover.x - c.x) * scale, (g.cover.y - c.y) * scale, g.cover.w * scale, g.cover.h * scale);
      x.restore();
      var obj = self.objFor(side);
      if (obj) {
        var e = self.effective(obj);
        var L = (e.x - e.w / 2 - c.x) * scale, T = (e.y - e.h / 2 - c.y) * scale;
        x.save(); x.globalCompositeOperation = 'screen';
        if (obj.kind === 'logo' && self.artImg) {
          x.save();
          x.translate((e.x - c.x) * scale, (e.y - c.y) * scale);
          if (e.r) x.rotate(e.r * Math.PI / 180);
          x.drawImage(self.artImg, -e.w * scale / 2, -e.h * scale / 2, e.w * scale, e.h * scale);
          x.restore();
        }
        if (obj.kind === 'text') {
          var fs = e.s * scale;
          x.font = '600 ' + fs + 'px Inter, system-ui, -apple-system, sans-serif';
          if ('letterSpacing' in x) x.letterSpacing = (fs * 0.06) + 'px';
          x.textAlign = 'center'; x.textBaseline = 'middle';
          var gr = x.createLinearGradient(0, T, 0, T + e.h * scale);
          gr.addColorStop(0, '#eceef1'); gr.addColorStop(0.55, '#c3c7cc'); gr.addColorStop(1, '#e4e6ea');
          x.fillStyle = gr;
          x.fillText(obj.text, (e.x - c.x) * scale, (e.y - c.y) * scale);
        }
        x.restore();
      }
      return cv;
    });
  };
  Customiser.prototype.renderReview = function () {
    var u = this.userHas(), self = this;
    $$('[data-cz-review]', this.scope).forEach(function (fig) {
      var side = fig.getAttribute('data-cz-review');
      var box = $('.cz-mini__art', fig);
      fig.classList.toggle('is-blank', !u[side]);
      var st = $('[data-cz-review-state]', fig);
      if (st) st.textContent = u[side] ? '' : (side === 'adro' ? '· ADRO logo only' : '· Not engraved');
      self.compose(side, 1.2).then(function (cv) {
        var img = box.querySelector('img') || box.appendChild(document.createElement('img'));
        img.src = cv.toDataURL('image/jpeg', 0.86);
        img.alt = SIDE_NAME[side] + (u[side] ? (side === 'logo' ? ': your logo' : ': ' + (self.mode === 'bulk' ? 'names above the ADRO logo' : 'your initials above the ADRO logo')) : (side === 'logo' ? ': not engraved' : ': ADRO logo only'));
      }).catch(function () { box.innerHTML = ''; });
    });
  };
  Customiser.prototype.previewPng = function () {
    var self = this;
    return Promise.all([this.compose('logo', 2), this.compose('adro', 2)]).then(function (cvs) {
      var w = cvs[0].width, h = cvs[0].height, pad = 20, head = 44;
      var c = document.createElement('canvas'); c.width = w * 2 + pad * 3; c.height = h + head + pad;
      var x = c.getContext('2d');
      x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height);
      x.fillStyle = '#1d1d1f'; x.font = '600 22px system-ui, sans-serif'; x.textAlign = 'center';
      cvs.forEach(function (cv, i) { x.drawImage(cv, pad + i * (w + pad), head); x.fillText(SIDE_NAME[SIDES[i]], pad + i * (w + pad) + w / 2, 30); });
      return new Promise(function (res) { c.toBlob(function (b) { res(b); }, 'image/png'); });
    }).catch(function () { return null; });
  };

  /* ----- initials / names list (bulk) ----- */
  function ranges(nums) {
    var out = [], i = 0;
    while (i < nums.length) {
      var a = nums[i], b = a;
      while (i + 1 < nums.length && nums[i + 1] === b + 1) { i++; b = nums[i]; }
      out.push(a === b ? String(a) : a + '–' + b); i++;
    }
    return out.join(', ');
  }
  Customiser.ranges = ranges;
  // Rebuild the numbered fields (only on structural changes, so typing never loses focus).
  Customiser.prototype.renderNameFields = function () {
    var el = this.el, st = this.state, max = this.cfg.maxText, uid = this.scope.getAttribute('data-cz-uid') || 'cz';
    if (!el.namesList) return;
    var frag = document.createDocumentFragment();
    (st.entries || []).forEach(function (v, i) {
      var n = i + 1, id = uid + '-n' + n;
      var li = document.createElement('li'); li.className = 'cz-nrow'; li.setAttribute('data-row', n);
      var lab = document.createElement('label'); lab.setAttribute('for', id); lab.className = 'cz-nrow__label';
      lab.textContent = 'Initials/name for bottle ' + n;
      var inp = document.createElement('input'); inp.type = 'text'; inp.className = 'input cz-nrow__input'; inp.id = id;
      inp.setAttribute('data-n', i); inp.maxLength = max; inp.autocomplete = 'off'; inp.spellcheck = false; inp.value = v || '';
      inp.setAttribute('aria-describedby', id + '-flag');
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'cz-nrow__rm'; rm.setAttribute('data-n-remove', i);
      rm.setAttribute('aria-label', 'Remove the entry for bottle ' + n);
      rm.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg>';
      var flag = document.createElement('span'); flag.className = 'cz-nrow__flag'; flag.id = id + '-flag';
      li.appendChild(lab); li.appendChild(inp); li.appendChild(rm); li.appendChild(flag);
      frag.appendChild(li);
    });
    el.namesList.innerHTML = ''; el.namesList.appendChild(frag);
    this.renderNamesStatus();
  };
  Customiser.prototype.renderNamesStatus = function () {
    var el = this.el, st = this.state;
    if (!el.namesToggle) return;
    var info = this.namesInfo(), q = st.qty || 0, max = this.cfg.maxText;
    show(el.namesWrap, info.on);
    show(el.namesSameWrap, info.on && !info.each);
    show(el.namesEachWrap, info.on && info.each);
    var msgs = [], tone = 'warn';
    if (!info.on) { el.namesMsg.hidden = true; return; }
    if (!info.each) {
      el.namesSameNote.textContent = info.same ? 'Engraved exactly as typed on all ' + q + ' bottles.' : 'The same initials or name go on all ' + q + ' bottles. You can also send them later.';
      el.namesCount.textContent = '';
      if (info.invalid.length) { msgs.push('Some characters can’t be engraved. Please use letters, numbers and simple punctuation.'); tone = 'error'; }
      if (info.tooLong.length) { msgs.push('Please keep it to ' + max + ' characters.'); tone = 'error'; }
      el.namesSame.setAttribute('aria-invalid', info.invalid.length ? 'true' : 'false');
    } else {
      var len = (st.entries || []).length;
      el.namesCount.textContent = info.assigned + ' of ' + q + ' bottles have initials/names';
      el.namesCount.className = 'cz-count cz-count--block' + (info.assigned === q && !info.over ? ' is-complete' : '');
      if (info.over) {
        tone = 'error';
        msgs.push('You have ' + len + ' entries but ' + q + ' bottles. Remove ' + info.over + (info.over === 1 ? ' entry' : ' entries') + ' (bottle' + (info.over === 1 ? ' ' : 's ') + ranges(range(q + 1, len)) + ') or increase the quantity.');
      }
      if (info.tooLong.length) { tone = 'error'; msgs.push('Bottle ' + ranges(info.tooLong) + ': longer than ' + max + ' characters. Please shorten ' + (info.tooLong.length === 1 ? 'it' : 'them') + '.'); }
      if (info.invalid.length) { tone = 'error'; msgs.push('Bottle ' + ranges(info.invalid) + ': some characters can’t be engraved. Please use letters, numbers and simple punctuation.'); }
      if (info.unassigned.length && !info.over) {
        msgs.push(info.unassigned.length === q
          ? 'No bottles have initials/names yet. Add them above, or send your list later.'
          : info.unassigned.length + (info.unassigned.length === 1 ? ' bottle' : ' bottles') + ' will have no initials/name: bottle' + (info.unassigned.length === 1 ? ' ' : 's ') + ranges(info.unassigned) + '. Nothing is copied to them automatically.');
      }
      var room = Math.max(0, q - len);
      el.namesAdd.disabled = room === 0; el.namesAdd10.disabled = room === 0;
      el.namesAdd.textContent = room ? 'Add bottle ' + (len + 1) : 'Add bottle';
      el.namesAdd10.textContent = 'Add ' + Math.max(1, Math.min(10, room)) + ' more';
      el.namesLimit.textContent = room ? 'You can add ' + room + ' more (one entry per bottle, up to ' + q + ').' : 'Every bottle has a field. Increase the quantity to add more.';
      var bad = {}; info.invalid.forEach(function (n) { bad[n] = 'Can’t be engraved'; }); info.tooLong.forEach(function (n) { bad[n] = 'Too long (max ' + max + ')'; });
      $$('.cz-nrow', el.namesList).forEach(function (row) {
        var n = +row.getAttribute('data-row'), inp = $('input', row), f = $('.cz-nrow__flag', row);
        var txt = n > q ? 'More than your ' + q + ' bottles' : (bad[n] || '');
        f.textContent = txt; row.classList.toggle('is-bad', !!txt);
        inp.setAttribute('aria-invalid', txt ? 'true' : 'false');
      });
    }
    el.namesMsg.innerHTML = '';
    msgs.forEach(function (m) { var p = document.createElement('span'); p.className = 'cz-msg__line'; p.textContent = m; el.namesMsg.appendChild(p); });
    el.namesMsg.hidden = !msgs.length; el.namesMsg.className = 'cz-msg cz-msg--' + tone;
  };
  function range(a, b) { var r = []; for (var i = a; i <= b; i++) r.push(i); return r; }

  /* ----- drafts ----- */
  Customiser.prototype.status = function (msg) { if (this.el.status) this.el.status.textContent = msg || ''; };
  Customiser.prototype._save = function () {
    var self = this, st = this.state;
    if (this._restoring) return;
    var hasSomething = this.userHas().any || st.namesOn || !!cleanText(st.sameName) || (st.entries || []).some(function (v) { return !!cleanText(v); });
    if (!hasSomething) { ls.del(this.key); idbDel(this.key); this.status(''); return; }
    var okLs = ls.set(this.key, st);
    if (!okLs) { this.status(''); return; }
    if (!st.logo) {
      if (this._artDirty) { idbDel(this.key); this._artDirty = false; }
      this.status('Design saved on this device');
      return;
    }
    if (!this.file) return;
    if (!this._artDirty && this._artSaved) { this.status('Design saved on this device'); return; }
    idbPut(this.key, { blob: this.file, name: st.logo.name, type: st.logo.type })
      .then(function () { self._artDirty = false; self._artSaved = true; self.status('Design saved on this device'); })
      .catch(function () { self._artSaved = false; self.status('Your text and settings are saved on this device. Your logo couldn’t be saved, so re-upload it if you come back later.'); });
  };
  Customiser.prototype.restore = function () {
    var self = this, saved = ls.get(this.key);
    if (!saved || (saved.v !== 1 && saved.v !== 2)) return;
    if (saved.v === 1) { // older draft: keep content, reset placement
      saved = { v: 2, side: saved.side === 'back' ? 'adro' : 'logo', logo: saved.logo ? { name: saved.logo.name, type: saved.logo.type, invert: saved.logo.invert, remoteUrl: saved.logo.remoteUrl } : null,
        text: saved.text || '', textPos: null, namesOn: !!saved.namesOn, names: saved.names || '', qty: saved.qty || null };
    }
    if (typeof saved.names === 'string' && !Array.isArray(saved.entries)) { // earlier one-per-line list
      var old = saved.names.split(/\n/).map(cleanText).filter(Boolean);
      if (old.length > 1) { saved.namesEach = true; saved.entries = old; } else { saved.namesEach = false; saved.sameName = old[0] || ''; saved.entries = []; }
    }
    delete saved.names;
    this._restoring = true;
    var logo = saved.logo;
    this.state = Object.assign(this.blank(), saved, { logo: null });
    this.syncInputs();
    this.setSide(saved.side || 'logo');
    var done = function (note) {
      self._restoring = false;
      if (self.el.restored) { self.el.restored.textContent = note; self.el.restored.hidden = false; }
      self.changed();
    };
    if (!logo) { done('We’ve restored your design from your last visit on this device.'); return; }
    idbGet(this.key).then(function (rec) {
      if (!rec || !rec.blob) throw new Error('missing');
      var f = rec.blob;
      try { f = new File([rec.blob], rec.name || logo.name, { type: rec.type || logo.type }); } catch (e) { f.name = rec.name; }
      self.state.logo = logo;
      return self.useFile(f, false).then(function (ok) {
        if (!ok) throw new Error('bad');
        self._artSaved = true; self._artDirty = false;
        self.state.logo.remoteUrl = logo.remoteUrl || null;
        done('We’ve restored your design from your last visit on this device.');
      });
    }).catch(function () {
      self.state.logo = null; self.file = null; self.setArt(null);
      done('We’ve restored your text and settings. Please re-upload your logo.');
    });
  };
  Customiser.prototype.resetDesign = function () {
    this.file = null; this.setArt(null); this._artDirty = true; this._artSaved = false;
    var keepQty = this.state.qty;
    this.state = this.blank(); this.state.qty = keepQty;
    ls.del(this.key); idbDel(this.key);
    this.logoMsg('');
    if (this.el.restored) this.el.restored.hidden = true;
    this.syncInputs();
    this.setSide('logo');
    this.changed();
    this.status('Design cleared');
    this.announce('Design cleared.');
  };
  Customiser.prototype.setQty = function (q) { var ch = this.state.qty !== q; this.state.qty = q; this.save(); if (ch) this.renderNamesStatus(); };

  window.AdroCustomiser = Customiser;

  // Artwork permission: required whenever a customer logo is included.
  function RightsCheck(scope, cz) {
    var wrap = $('[data-rights]', scope), box = $('[data-rights-input]', scope), msg = $('[data-rights-msg]', scope);
    function sync() {
      if (!wrap) return;
      var need = cz.summary().hasLogo;
      wrap.hidden = !need; box.required = need;
      if (!need) { msg.hidden = true; box.removeAttribute('aria-invalid'); }
    }
    if (box) box.addEventListener('change', function () { if (box.checked) { msg.hidden = true; box.removeAttribute('aria-invalid'); } });
    cz.on(sync); sync();
    return {
      ok: function () {
        if (!wrap || !cz.summary().hasLogo || box.checked) return true;
        msg.hidden = false; box.setAttribute('aria-invalid', 'true'); box.focus();
        return false;
      },
      value: function () { return cz.summary().hasLogo && box && box.checked ? 'Confirmed by customer' : ''; }
    };
  }

  /* ================= Individual purchase ================= */
  function SinglePurchase(scope) {
    var cfg = JSON.parse($('[data-sp-config]', scope).textContent);
    var cz = new Customiser(scope);
    var rights = RightsCheck(scope, cz);
    var qtyIn = $('[data-sp-qty]', scope);
    var addBtn = $('[data-sp-add]', scope);
    var errEl = $('[data-sp-error]', scope);
    var busy = false;

    if (cz.state.qty) qtyIn.value = cz.state.qty;

    function engraving(s) {
      if (s.hasLogo && s.hasText) return { key: 'both', label: 'Logo + initials', v: cfg.engraving.both };
      if (s.hasLogo) return { key: 'logo', label: 'Logo', v: cfg.engraving.logo };
      if (s.hasText) return { key: 'name', label: 'Initials', v: cfg.engraving.name };
      return null;
    }
    function qty() { var q = parseInt(qtyIn.value, 10); return isNaN(q) || q < 1 ? 1 : Math.min(q, 99); }

    function render() {
      var s = cz.summary(), e = engraving(s), q = qty();
      var ep = e && e.v ? e.v.price : 0;
      var unit = cfg.price + ep, total = unit * q;
      var saveTxt = '';
      if (e && e.key === 'both' && cfg.engraving.logo && cfg.engraving.name) {
        var sv = cfg.engraving.logo.price + cfg.engraving.name.price - e.v.price;
        if (sv > 0) saveTxt = ' (save ' + money(sv) + ')';
      }
      $('[data-sp-engraving]', scope).textContent = e ? e.label + ' · ' + money(ep) + ' per bottle' + saveTxt : 'None';
      show($('[data-sp-text-row]', scope), s.hasText);
      $('[data-sp-text]', scope).textContent = s.text;
      $('[data-sp-qty-out]', scope).textContent = q;
      $('[data-sp-bottle]', scope).textContent = q > 1 ? q + ' × ' + money(cfg.price) : money(cfg.price);
      show($('[data-sp-engr-row]', scope), !!e);
      $('[data-sp-engr-price]', scope).textContent = e ? (q > 1 ? q + ' × ' + money(ep) : money(ep)) : '';
      $('[data-sp-total]', scope).textContent = money(total);
      $('[data-sp-bar-total]', scope).textContent = money(total);
      $('[data-sp-bar-label]', scope).textContent = e ? cfg.title + ' + ' + e.label.toLowerCase() : cfg.title;
      if (cfg.available && !busy) {
        addBtn.textContent = 'Add to bag · ' + money(total);
        addBtn.disabled = !s.textValid;
      }
      show($('[data-sp-bulk-hint]', scope), q >= 10);
    }

    qtyIn.addEventListener('input', function () { cz.setQty(qty()); render(); });
    qtyIn.addEventListener('change', function () { qtyIn.value = qty(); cz.setQty(qty()); render(); });
    $$('[data-qty] [data-step]', scope).forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(function () { qtyIn.value = qty(); cz.setQty(qty()); render(); }, 0); });
    });
    cz.on(render);
    render();

    function fail(msg) { errEl.textContent = msg; errEl.hidden = false; busy = false; render(); }

    addBtn.addEventListener('click', function () {
      if (busy) return;
      var s = cz.summary(), e = engraving(s), q = qty();
      if (!s.textValid) { fail('Please remove characters that can’t be engraved.'); return; }
      if (!rights.ok()) return;
      if (e && !e.v) { fail('Engraving isn’t available right now. Please try again later.'); return; }
      busy = true; errEl.hidden = true;
      addBtn.disabled = true; addBtn.textContent = 'Adding to bag…';
      var link = 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

      var previewP = e ? cz.previewPng() : Promise.resolve(null);
      previewP.then(function (preview) {
        var fd = new FormData();
        fd.append('id', cfg.variantId);
        fd.append('quantity', q);
        if (e) {
          fd.append('properties[Engraving]', e.label);
          if (s.hasLogo) {
            fd.append('properties[Logo side]', 'Opposite the ADRO logo');
            fd.append('properties[Logo artwork]', s.file, s.logo.name);
            fd.append('properties[Logo placement]', s.logoPlacement);
            if (s.logo.invert) fd.append('properties[Logo colours]', 'Inverted (light artwork)');
            fd.append('properties[Artwork permission]', rights.value());
          }
          if (s.hasText) {
            fd.append('properties[Initials side]', 'ADRO logo side, above the ADRO logo');
            fd.append('properties[Initials]', s.text);
            fd.append('properties[Initials placement]', s.textPlacement);
          }
          if (preview) fd.append('properties[_Engraving preview]', preview, 'engraving-preview.png');
          fd.append('properties[_design]', link);
        }
        return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'add'); return j; });
      }).then(function (line) {
        if (!e) return line;
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: e.v.id, quantity: q, properties: { _design: link, For: cfg.title } }] })
        }).then(function (r2) {
          if (r2.ok) return line;
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) })
            .then(function () { throw new Error('We couldn’t add engraving to your bag, so nothing was added. Please try again.'); });
        });
      }).then(function () {
        window.location.href = cfg.cartUrl;
      }).catch(function (err) {
        var m = err && err.message;
        if (!m || m === 'add' || m === 'Failed to fetch') m = 'Something went wrong adding this to your bag. Please check your connection and try again.';
        if (/file/i.test(m) && s.hasLogo) m = 'Your logo couldn’t be uploaded. Please try again, or try a smaller PNG or JPG.';
        fail(m);
      });
    });
  }

  /* ================= Bulk quote ================= */
  function BulkQuote(scope) {
    var cfg = JSON.parse($('[data-quote-config]', scope).textContent);
    var cz = new Customiser(scope);
    var rights = RightsCheck(scope, cz);
    var tiers = cfg.tiers.slice().sort(function (a, b) { return a.min - b.min; });
    var range = $('[data-q-range]', scope), number = $('[data-q-number]', scope);
    var chips = $$('[data-q-bundle]', scope);
    var qMsg = $('[data-q-qty-msg]', scope);
    var form = $('#quote-form', scope);
    var errEl = $('[data-q-error]', scope), fallback = $('[data-q-fallback]', scope), submitBtn = $('[data-q-submit]', scope);
    var out = function (k) { return $('[data-q-' + k + ']', scope); };
    var current = cfg.default_qty;
    var sending = false, bypass = false;

    function tierFor(q) { var t = tiers[0]; tiers.forEach(function (x) { if (q >= x.min) t = x; }); return t; }
    function nextTier(q) { for (var i = 0; i < tiers.length; i++) if (q < tiers[i].min && tiers[i].rate != null) return tiers[i]; return null; }
    function addonFor(t) { return t && t.addon != null ? t.addon : cfg.addon; }

    function setQty(v, src, clampNow) {
      var q = parseInt(v, 10);
      if (isNaN(q)) q = cfg.min;
      var msg = '';
      if (clampNow || src !== 'number') {
        if (q < cfg.min) { msg = 'Bulk orders start at ' + cfg.min + ' bottles. For fewer, shop single bottles.'; q = cfg.min; }
        if (q > cfg.max) { msg = 'Bulk orders go up to ' + cfg.max + ' bottles. For more, mention it in your message and we’ll help.'; q = cfg.max; }
        if (src !== 'number' || clampNow) number.value = q;
      } else if (q < cfg.min || q > cfg.max) {
        msg = 'Please choose between ' + cfg.min + ' and ' + cfg.max + ' bottles.';
      }
      qMsg.textContent = msg; qMsg.hidden = !msg;
      number.setAttribute('aria-invalid', (q < cfg.min || q > cfg.max) ? 'true' : 'false');
      if (q < cfg.min || q > cfg.max) { render(Math.min(Math.max(q, cfg.min), cfg.max)); return; }
      if (src !== 'range') range.value = q;
      current = q;
      cz.setQty(q);
      render(q);
    }

    function render(q) {
      q = q || current;
      var s = cz.summary();
      var t = tierFor(q), priced = t.rate != null;
      var rateP = priced ? toP(t.rate) : null;
      var addEach = toP(addonFor(t));
      var ni = s.namesInfo || { on: false };
      // Existing fee rule: the add-on is charged per bottle that is engraved with initials/names.
      // Same on every bottle = every bottle. Different per bottle = each bottle with an entry.
      var nBottles = ni.on ? (ni.each ? ni.assigned : q) : 0;
      var addP = addEach * nBottles;
      var bottlesP = priced ? rateP * q : null;
      var totalP = priced ? bottlesP + addP : null;
      var retailP = toP(cfg.retail) * q;
      var saveP = priced ? Math.max(0, retailP - bottlesP) : 0;

      $('[data-q-names-price]', scope).textContent = '+' + money(addEach) + ' per bottle';
      out('tier').textContent = priced ? t.name + ' pricing' : 'Price to be confirmed';
      out('total').textContent = priced ? money(totalP) : 'To be confirmed';
      out('per').textContent = priced ? money(Math.round(totalP / q)) + ' average per bottle' + (nBottles ? ' incl. initials' : '') + ' · ' + q + ' bottles' : q + ' bottles · we’ll confirm the price in your quote';
      out('bottles').textContent = priced ? money(bottlesP) : 'To be confirmed';
      out('rate').textContent = priced ? q + ' × ' + money(rateP) : '';
      show(out('addon-row'), s.namesOn);
      out('addon').textContent = '+' + money(addP) + ' (' + nBottles + ' × ' + money(addEach) + ')';
      var ab = out('addon-bottles'); if (ab) ab.textContent = ni.on ? (ni.each ? nBottles + ' of ' + q + ' bottles' : 'all ' + q + ' bottles') : '';
      show(out('retail-row'), priced);
      out('retail').textContent = money(retailP);
      show(out('save-row'), priced && saveP > 0);
      out('save').textContent = '−' + money(saveP);
      var warn = out('warn');
      warn.textContent = priced ? '' : 'Pricing for this quantity isn’t published yet. Send your request and we’ll confirm it with your quote.';
      warn.hidden = priced;
      var nt = nextTier(q), nudge = out('nudge');
      if (nt) {
        var extra = nt.min - q;
        nudge.textContent = 'Add ' + extra + ' more bottle' + (extra === 1 ? '' : 's') + ' to reach ' + nt.name + ' pricing at ' + money(toP(nt.rate)) + ' each.';
        nudge.hidden = false;
      } else nudge.hidden = true;
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(+c.getAttribute('data-q-bundle') === q)); });
      $('[data-q-bar-total]', scope).textContent = priced ? money(totalP) : 'To be confirmed';
      $('[data-q-bar-label]', scope).textContent = q + ' bottles' + (nBottles ? ' + initials' : '') + ' · estimate';

      // Review
      $('[data-q-rv-logo]', scope).textContent = s.hasLogo ? s.logo.name + ' · opposite the ADRO logo · included' : 'Not added yet. You can send your logo later.';
      var rvNames = 'Not included';
      if (ni.on && !ni.each) rvNames = (ni.same ? '“' + ni.same + '” on all ' + q + ' bottles' : 'Same on all ' + q + ' bottles · to follow') + ' · ' + money(addP);
      if (ni.on && ni.each) rvNames = ni.assigned + ' of ' + q + ' bottles personalised · ' + money(addP) + (ni.unassigned.length && !ni.over ? ' · ' + ni.unassigned.length + ' without' : '') + (ni.over ? ' · ' + ni.over + ' too many entries' : '');
      $('[data-q-rv-names]', scope).textContent = rvNames;
      var list = out('rv-list'); list.innerHTML = '';
      if (ni.on && ni.each) ni.filled.forEach(function (f) { var li = document.createElement('li'); li.value = f.n; li.textContent = f.text; if (f.n > q) li.className = 'is-over'; list.appendChild(li); });
      show($('[data-q-rv-list-row]', scope), !!(ni.on && ni.each && ni.filled.length));
      $('[data-q-rv-qty]', scope).textContent = q + ' bottles';
      $('[data-q-rv-total]', scope).textContent = priced ? money(totalP) + ' (' + t.name + ')' : 'Price to be confirmed';

      // Hidden fields sent with the request (never includes example artwork)
      var set = function (k, v) { var el = $('[data-q-field="' + k + '"]', scope); if (el) el.value = v; };
      set('qty', q);
      set('tier', priced ? t.name : t.name + ' (price to be confirmed)');
      set('rate', priced ? money(rateP) : 'To be confirmed');
      var feeTxt = nBottles + ' × ' + money(addEach) + ' = ' + money(addP);
      set('names', !ni.on ? 'No' : (ni.each ? 'Yes, different on each bottle: ' + ni.assigned + ' of ' + q + ' bottles (' + feeTxt + ')' : 'Yes, the same on every bottle (' + feeTxt + ')' + (ni.same ? '' : ', text to follow')));
      set('names_list', !ni.on ? '' : (ni.each ? ni.filled.map(function (f) { return 'Bottle ' + f.n + ': ' + f.text; }).join('\n') : (ni.same ? 'All ' + q + ' bottles: ' + ni.same : '')));
      set('names_unassigned', ni.on && ni.each && ni.unassigned.length ? 'Bottle' + (ni.unassigned.length === 1 ? ' ' : 's ') + Customiser.ranges(ni.unassigned) + ' (' + ni.unassigned.length + ' of ' + q + '): no initials/name requested' : '');
      set('names_place', s.namesOn && s.names.length ? 'ADRO logo side, above the ADRO logo; ' + s.textPlacement : '');
      set('total', priced ? money(totalP) : 'To be confirmed');
      set('saving', priced ? money(saveP) : '');
      set('logo_place', s.hasLogo ? 'Opposite the ADRO logo; ' + s.logoPlacement + (s.logo.invert ? '; artwork inverted' : '') : '');
      set('sides', (s.hasLogo ? 'Customer logo opposite the ADRO logo' : 'No logo yet') + (s.namesOn ? '; initials/names above the ADRO logo' : ''));
      set('rights', rights.value());
      if (!s.hasLogo) set('logo_file', '');
    }

    range.addEventListener('input', function () { setQty(range.value, 'range'); });
    number.addEventListener('input', function () { if (number.value !== '') setQty(number.value, 'number'); });
    number.addEventListener('blur', function () { setQty(number.value, 'number', true); });
    chips.forEach(function (c) { c.addEventListener('click', function () { setQty(c.getAttribute('data-q-bundle'), 'chip'); }); });
    cz.on(function () { render(); });
    var rb = $('[data-rights-input]', scope); if (rb) rb.addEventListener('change', function () { render(); });

    $$('[data-cz-goto]', scope).forEach(function (b) {
      b.addEventListener('click', function () {
        var target = b.getAttribute('data-cz-goto') === 'qty' ? number : ($('[data-cz-drop]', scope).hidden ? $('[data-cz-logo-replace]', scope) : $('[data-cz-drop]', scope));
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { try { (target.querySelector('input') || target).focus({ preventScroll: true }); } catch (e) { /* ignore */ } }, 400);
      });
    });

    // Starting quantity: URL (?qty= or ?bundle=), then saved draft, then default
    var params = new URLSearchParams(window.location.search);
    var start = cz.state.qty || cfg.default_qty;
    if (params.get('qty')) start = params.get('qty');
    if (params.get('bundle')) {
      var b = params.get('bundle').toLowerCase();
      chips.forEach(function (c) { if ((c.getAttribute('data-q-bundle-name') || '').toLowerCase() === b) start = c.getAttribute('data-q-bundle'); });
    }
    if (params.get('names') === '1' && !cz.state.namesOn) { cz.state.namesOn = true; cz.syncInputs(); cz.changed(); }
    $$('[data-q-step]', scope).forEach(function (b) {
      b.addEventListener('click', function () {
        var d = +b.getAttribute('data-q-step'), v = parseInt(number.value, 10);
        if (isNaN(v)) v = current;
        setQty(Math.min(cfg.max, Math.max(cfg.min, v + d)), 'step', true);
      });
    });
    setQty(start, 'init', true);

    // Upload the logo through the cart (the only file-upload route Shopify offers a theme) so the quote email carries a link.
    function uploadLogo() {
      var s = cz.summary();
      if (!s.hasLogo) return Promise.resolve(null);
      if (s.logo.remoteUrl) return Promise.resolve(s.logo.remoteUrl);
      if (!cfg.uploadVariant) return Promise.reject(new Error('unavailable'));
      var fd = new FormData();
      fd.append('id', cfg.uploadVariant);
      fd.append('quantity', 1);
      fd.append('properties[Artwork]', s.file, s.logo.name);
      fd.append('properties[_quote_upload]', '1');
      return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'upload'); return j; }); })
        .then(function (line) {
          var url = line.properties && (line.properties.Artwork || line.properties['Artwork']);
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) })
            .then(function () {
              if (!url || !/^https?:\/\//.test(url)) throw new Error('upload');
              cz.state.logo.remoteUrl = url; cz.save();
              return url;
            });
        });
    }

    function sendNow() {
      bypass = true;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }

    form.addEventListener('submit', function (ev) {
      if (bypass) return;
      ev.preventDefault();
      if (sending) return;
      if (!rights.ok()) return;
      if (!form.reportValidity()) return;
      if (current < cfg.min || current > cfg.max) { number.focus(); return; }
      var nInfo = cz.summary().namesInfo;
      if (nInfo && nInfo.on && nInfo.block) {
        var nm = $('[data-cz-msg-names]', scope);
        errEl.textContent = 'Please fix the initials/names list before sending. ' + (nm ? $$('.cz-msg__line', nm).map(function (l) { return l.textContent; }).join(' ') : '');
        errEl.hidden = false;
        var target = $('.cz-nrow.is-bad input', scope) || $('[data-cz-names-same]', scope);
        if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { target.focus({ preventScroll: true }); }, 350); }
        return;
      }
      sending = true; errEl.hidden = true; fallback.hidden = true;
      submitBtn.disabled = true; submitBtn.textContent = cz.summary().hasLogo ? 'Attaching your logo…' : 'Sending…';
      render();
      uploadLogo().then(function (url) {
        $('[data-q-field="logo_file"]', scope).value = url || (cz.summary().hasLogo ? '' : 'Not supplied yet');
        submitBtn.textContent = 'Sending…';
        sendNow();
      }).catch(function () {
        sending = false; submitBtn.disabled = false; submitBtn.textContent = 'Send quote request';
        errEl.textContent = 'We couldn’t attach your logo file. You can try again, or send your request now and email the logo when we reply.';
        errEl.hidden = false; fallback.hidden = false;
      });
    });
    $('[data-q-send-anyway]', scope).addEventListener('click', function () {
      $('[data-q-field="logo_file"]', scope).value = 'Uploaded in the preview but not attached. Please ask the customer to email it.';
      fallback.hidden = true; submitBtn.disabled = true; submitBtn.textContent = 'Sending…';
      sendNow();
    });
    $('[data-q-retry]', scope).addEventListener('click', function () { fallback.hidden = true; errEl.hidden = true; form.dispatchEvent(new Event('submit', { cancelable: true })); });
  }

  /* ================= Cookie preferences link ================= */
  function cookieLinks() {
    $$('[data-cookie-prefs]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { e.preventDefault(); window.privacyBanner.showPreferences(); }
      });
    });
  }

  /* ================= Init ================= */
  function init() {
    $$('[data-sp]').forEach(function (s) { try { SinglePurchase(s); } catch (e) { console.error('ADRO customiser', e); } });
    $$('[data-quote]').forEach(function (s) { try { BulkQuote(s); } catch (e) { console.error('ADRO quote', e); } });
    cookieLinks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
